import { render, staticRenderFns } from "./orderingInfo.vue?vue&type=template&id=f508eb48&scoped=true&"
import script from "./orderingInfo.vue?vue&type=script&lang=js&"
export * from "./orderingInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderingInfo.vue?vue&type=style&index=0&id=f508eb48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f508eb48",
  null
  
)

export default component.exports